import { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'


class ScrollTop extends PureComponent {
  /* LIFECYCLE */

  /**
   * @componentWillReceiveProps
   * @param {*} prevProps - Previous Properties of the PureComponent
   */
  componentDidUpdate(prevProps) {
    const { location } = prevProps

    if (location.pathname !== this.props.location.pathname) {
      window.scrollTo(0, 0)
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    return this.props.children
  }
}


ScrollTop.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
}


export default withRouter(ScrollTop)
